<div class="order-content">
  <ng-content select=".content"></ng-content>

  <div
    class="side-menu"
    (clickOutside)="fastaccessservcie.closeSidebar($event)"
    [class.hideFastAccess]="!fastaccessservcie.order.hideFastAccess && fastaccessservcie.common.isMobileMode">
    <div class="side">
      <div
        *ngIf="
          fastaccessservcie.order.showChangeFactor &&
          fastaccessservcie.order.saleMethodBranch.IsChangeTheSalesMethod &&
          fastaccessservcie.order.currentActivePage === fastaccessservcie.order.activePageEnum.Order
        "
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.Invoice)">
        <i class="icon icon-change-svgrepo-com"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Factor" | translate }}</div>
      </div>
      <div
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsSalonFastAccess"
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.Salon)">
        <i class="icon icon-table-chair"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Table" | translate }}</div>
      </div>
      <div
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsDriverAssignmentFastAccess"
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.DriverAssignment)">
        <i class="icon icon-motorcycle-svgrepo-com"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Driver" | translate }}</div>
      </div>
      <div
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsCustomreFastAccess"
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.Customer)">
        <i class="icon-account-multiple icon"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Customer" | translate }}</div>
      </div>
      <div
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsWaiterFastAccess"
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.Waiter)">
        <i class="icon icon-waiter-svgrepo-com"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Waiter" | translate }}</div>
      </div>
      <div
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsPagerFastAccess"
        class="shortcut"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.pager)"
        placement="right">
        <i class="icon icon-aounting"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Pager" | translate }}</div>
      </div>
      <div
        class="shortcut"
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsClubFastAccess && fastaccessservcie.hasClub"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.club)">
        <i class="icon icon-waiter-svgrepo-com"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Club" | translate }}</div>
      </div>
      <div
        class="shortcut"
        *ngIf="fastaccessservcie.order.saleMethodBranch.IsPaymentLink && fastaccessservcie.order?.currentInformation?.PaymentPanelAVA"
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.PaymentLink)">
        <i class="icon icon-ad_units-F"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.PaymentLink" | translate }}</div>
      </div>
      <div
        class="shortcut"
        *ngIf="
          fastaccessservcie.order.currentActivePage === fastaccessservcie.order.activePageEnum.Order &&
          fastaccessservcie.order.saleMethodBranch.HasDelino &&
          fastaccessservcie.order.saleMethodBranch.HasDelinoOfflineFactor
        "
        (click)="fastaccessservcie._toggleOpened(fastaccessservcie.fastAccessEnum.DelinoOfflineFactor)"
        placement="right">
        <i class="icon icon-aounting"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.DelinoOfflineFactor" | translate }}</div>
      </div>
      <div
        class="shortcut"
        *ngIf="
          fastaccessservcie.order?.currentInformation?.HasProtel &&
          fastaccessservcie.order.currentSaleMethodNature === fastaccessservcie.order.SaleMethodNature.Restaurant
        "
        (click)="fastaccessservcie.GetProtelInfo()"
        placement="right">
        <i class="icon icon-announcement-o"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Protel" | translate }}</div>
      </div>
      <div *ngIf="fastaccessservcie.order.hasPosScale" class="shortcut mt-auto" (click)="fastaccessservcie.order.posScaleService.tare()">
        <i class="icon icon-packing"></i>
        <div class="shortcutname">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Tare" | translate }}</div>
      </div>
    </div>
    <div class="fast-access" [class.fast-access-open]="fastaccessservcie.order._opened" *ngIf="fastaccessservcie.order._opened">
      <order-waiterfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.Waiter && fastaccessservcie.order._opened">
      </order-waiterfastaccess>
      <order-pagerfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.pager && fastaccessservcie.order._opened">
      </order-pagerfastaccess>
      <order-driverassignmentfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.DriverAssignment && fastaccessservcie.order._opened">
      </order-driverassignmentfastaccess>
      <order-customerfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.Customer && fastaccessservcie.order._opened">
      </order-customerfastaccess>
      <order-salonfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.Salon && fastaccessservcie.order._opened">
      </order-salonfastaccess>
      <order-invoicechangefastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.Invoice && fastaccessservcie.order._opened">
      </order-invoicechangefastaccess>
      <order-clubfastacces
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.club && fastaccessservcie.order._opened">
      </order-clubfastacces>
      <order-paymentlinkfastaccess
        *ngIf="fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.PaymentLink && fastaccessservcie.order._opened">
      </order-paymentlinkfastaccess>
      <order-delino-offlinefactor
        *ngIf="
          fastaccessservcie.order.selectedFastAccess === fastaccessservcie.fastAccessEnum.DelinoOfflineFactor && fastaccessservcie.order._opened
        ">
      </order-delino-offlinefactor>
    </div>
  </div>
</div>
